<gbc-page-error-handler [content]="content" [pageError$]="pageError$"></gbc-page-error-handler>
<ng-template #content>
  <gbc-page-header [pageInfo]="pageInfo$ | async">
    <ng-container gbc-page-header-actions>
      <button gbc-menu-item
        (click)="editFacility()"
        angulartics2On="click"
        angularticsAction="editFacilityShown"
        angularticsCategory="mixitFacility">
        <img style="margin-right: 10px" src="./assets/svgs/edit.svg" />
        {{'mixit-facility-page.edit-facility' | translate}}
      </button>

      <button gbc-menu-item
        (click)="deleteFacility()"
        angulartics2On="click"
        angularticsAction="deleteFacilityClicked"
        angularticsCategory="mixitFacility">
        <img style="margin-right: 10px; width: 16px;" src="./assets/svgs/trash-can_outline.svg" />
        {{'mixit-facility-page.delete-facility' | translate}}
      </button>
    </ng-container>
  </gbc-page-header>
  <gbc-page-container>

    @for (alarm of mostImportantAlarmByInstallation$ | async | keyvalue; track alarm) {
      <div>
        <app-alarm-bar
          [alarm]="alarm.value"
          showAlarmName="true">
        </app-alarm-bar>
      </div>
    }

    @if ((commissionState$ | async) === 'Error') {
      <div class="warning-bar">
        <img class="img" src="./assets/svgs/warning.svg" />
        <div class="connection-state-label" [innerHtml]="'mixit-device-states.error-for-device-to-connect' | translate"></div>
      </div>
    }

    @if (islessThanHalfHourSinceClaim$ | async) {
      <gbc-banner type="info" class="mt-8">
        <div [innerHtml]="'mixit-device-states.waiting-for-device-to-connect' | translate"></div>
      </gbc-banner>
    }

    @if (schematics$ | async; as schematics) {
      <gbc-tile [title]="'mixit-facility-page.mixing-loops' | translate" class="schematics-tile">
        <div class="schematics-container">
          @for (installationAndSchematic of schematics; track installationAndSchematic) {
            <div class="schematic-container">
              <div class="schematic-title-container">
                <div class="schematic-meta">
                  <span class="schematic-license-label">
                    @if (installationAndSchematic.isConnect && !installationAndSchematic.isDynamic) {
                      {{'schematic.connect' | translate}}
                    }
                    @if (installationAndSchematic.isDynamic && !installationAndSchematic.isConnect) {
                      {{'schematic.dynamic' | translate}}
                    }
                    @if (!installationAndSchematic.isDynamic && !installationAndSchematic.isConnect) {
                      {{'schematic.freemium' | translate}}
                    }
                    @if (installationAndSchematic.isDynamic && installationAndSchematic.isConnect) {
                      {{'schematic.connect' | translate}} + {{'schematic.dynamic' | translate}}
                    }
                  </span>
                  <button gbc-text-button
                    class="schematic-edit-button"
                    type="button"
                    (click)="editInstallation(installationAndSchematic.installation.id)"
                    angulartics2On="click"
                    angularticsAction="editInstallationShown"
                    angularticsCategory="mixitFacility">
                  {{'mixit-facility-page.edit' | translate}}</button>
                </div>
                <div class="schematic-title">
                  @if (installationAndSchematic.appModel) {
                    <app-last-updated [installationId]="installationAndSchematic.installation.id" [applicationId]="installationAndSchematic.appModel.systems[0].hasId" ></app-last-updated>
                  }
                  <h4>
                    {{installationAndSchematic.installation.name}}
                  </h4>
                </div>
              </div>
              @if (installationAndSchematic.appModel) {
                <app-schematic
                  (applicationClicked)="handleClick(installationAndSchematic.installation)"
                  [installationId]="installationAndSchematic.installation.id"
                  [schematic]="installationAndSchematic.appModel"
                  [dataPoints]="(data$ | async)"
                  [alarms]="[installationAndSchematic.alarm]"
                  class="schematic"
                  angulartics2On="click"
                  angularticsAction="applicationClicked"
                  angularticsCategory="mixitSchematic">
                </app-schematic>
              }
              @if (!installationAndSchematic.appModel) {
                <p style="text-align: center;">{{'mixit-facility-page.schematic-not-found' | translate}}</p>
              }
            </div>
          }
          @if (schematics.length === 0 && (hasInstallations$ | async)) {
            <div class="no-installations">
              <gbc-loading-spinner></gbc-loading-spinner>
            </div>
          }
          @if ((hasInstallations$ | async) === false) {
            <div class="no-installations">
              <p>{{'mixit-facility-page.no-installations' | translate}}</p>
              <button gbc-button
                [routerLink]="['/mixit', 'onboarding']"
                data-test-id="claim-device"
                angulartics2On="click"
                angularticsAction="claimDeviceClicked"
                angularticsCategory="mixitFacility">
              {{'mixit-facility-page.claim-device' | translate}}</button>
            </div>
          }
        </div>
      </gbc-tile>
    }

    @if (showAverageTiles$ | async) {
      <div class="tiles">
        <gbc-tile class="tile">
          <div class="facility-tile-content">
            <div class="tile-title">{{'mixit-facility-page.average-outdoor-temperature' | translate}}</div>
            <div class="tile-value">{{outDoorTemperature$ | async}}°</div>
          </div>
        </gbc-tile>
        <gbc-tile class="tile">
          <div class="facility-tile-content">
            <div class="tile-title">{{'mixit-facility-page.average-delta-t-primary' | translate}}</div>
            <div class="tile-value">{{averageDeltaT$ | async}}</div>
          </div>
        </gbc-tile>
      </div>
    }

  </gbc-page-container>
</ng-template>
